'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import { AppShell } from '@/components/layout/app-shell'
import { SignedOut } from '@/lib/auth/context'

/**
 * Chrome do site. Header global sempre. O AppShell adiciona a SIDEBAR da área
 * logada em TODAS as páginas (o próprio AppShell não renderiza sidebar pra
 * deslogado/admin). Footer público só pra quem NÃO está logado.
 *
 * Layout em coluna flex + main flex-1 evita scroll fantasma do antigo
 * min-h-screen no main (que somava header/footer além de 100vh).
 */
export function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const isBareShell =
    pathname.startsWith('/admin') || pathname === '/painel' || pathname === '/links'

  if (isBareShell) {
    return <>{children}</>
  }

  return (
    <div className="flex min-h-dvh flex-col">
      <Header />
      <main id="main-content" className="flex-1">
        <AppShell>{children}</AppShell>
      </main>
      <SignedOut>
        <Footer />
      </SignedOut>
    </div>
  )
}
